export default {
  'common': {
    'add': 'Adicionar',
    'cancel': 'Cancelar',
    'description': 'Descrição',
    'delete': 'Excluir',
    'title': 'Título',
    'save': 'Gravar',
    'faq': 'Perguntas frequentes',
    'contact': 'Contate-Nos',
    'tos': 'Termos de serviço',
    'policy': 'Política de Privacidade'
  },
  'board': {
    'titlePlaceholder': 'Insira um título para este cartão',
    'deleteDescription': 'Tem certeza de que deseja excluir este cartão?',
    'editCard': 'Editar Cartão',
    'deleteCard': 'Apagar cartão',
    'state': {
      'TODO': 'FAÇAM',
      'INPROGRESS': 'EM PROGRESSO',
      'TESTING': 'TESTE',
      'DONE': 'FEITO'
    }
  },
  'chat': {
    'online': 'Usuários online ({count})',
    'addChannel': 'Adicionar Canal',
    'channel': 'Canal | Canais',
    'message': 'mensagem'
  },
  'email': {
    'compose': 'Escrever um email',
    'send': 'Enviar',
    'subject': 'Sujeito',
    'labels': 'Etiquetas',
    'emptyList': 'Lista de e-mail vazia',
    'inbox': 'Caixa de entrada',
    'sent': 'Enviei',
    'drafts': 'Rascunhos',
    'starred': 'Estrelou',
    'trash': 'Lixo',
    'work': 'Trabalhos',
    'invoice': 'Fatura'
  },
  'todo': {
    'addTask': 'Adicionar Tarefa',
    'tasks': 'Tarefas',
    'completed': 'Concluído',
    'labels': 'Etiquetas'
  },
  'dashboard': {
    'activity': 'Atividade',
    'weeklySales': 'Vendas Semanais',
    'sales': 'Vendas',
    'recentOrders': 'Pedidos recentes',
    'sources': 'Fontes de tráfego',
    'lastweek': 'vs semana passada',
    'orders': 'Pedidos',
    'customers': 'Clientes',
    'tickets': 'Tickets de Suporte',
    'viewReport': 'Ver relatório'
  },
  'usermenu': {
    'profile': 'Perfil',
    'signin': 'Assinar em',
    'dashboard': 'painel de controle',
    'signout': 'Sair'
  },
  'error': {
    'notfound': 'Página não encontrada',
    'other': 'Ocorreu um erro'
  },
  'check': {
    'title': 'Definir nova senha',
    'backtosign': 'Voltar para Entrar',
    'newpassword': 'Nova senha',
    'button': 'Defina uma nova senha e faça login',
    'error': 'O link de ação é inválido',
    'verifylink': 'Verificando link ...',
    'verifyemail': 'Verificando endereço de e-mail ...',
    'emailverified': 'Email verificado! Redirecionando...'
  },
  'forgot': {
    'title': 'Esqueceu a senha?',
    'subtitle': 'Insira o endereço de e-mail da sua conta e enviaremos um link para redefinir sua senha.',
    'email': 'O email',
    'button': 'Solicitar redefinição de senha',
    'backtosign': 'Voltar para Entrar'
  },
  'login': {
    'title': 'Assinar em',
    'email': 'O email',
    'password': 'Senha',
    'button': 'Assinar em',
    'orsign': 'Ou faça login com',
    'forgot': 'Esqueceu a senha?',
    'noaccount': 'Não tem conta?',
    'create': 'Crie um aqui',
    'error': 'A combinação de e-mail / senha é inválida'
  },
  'register': {
    'title': 'Criar Conta',
    'name': 'Nome completo',
    'email': 'O email',
    'password': 'Senha',
    'button': 'Criar Conta',
    'orsign': 'Ou inscreva-se com',
    'agree': 'Ao se inscrever, você concorda com os',
    'account': 'já tem uma conta?',
    'signin': 'Assinar em'
  },
  'utility': {
    'maintenance': 'Em manutenção'
  },
  'faq': {
    'call': 'Tem outras perguntas? Por favor entre em contato'
  },
  'ecommerce': {
    'products': 'Produtos',
    'filters': 'Filtros',
    'collections': 'Coleções',
    'priceRange': 'Faixa de preço',
    'customerReviews': 'Avaliações de Clientes',
    'up': 'para cima',
    'brand': 'Marca',
    'search': 'Pesquisar produto',
    'results': 'Resultados ({0} de {1})',
    'orders': 'Pedidos',
    'shipping': 'Remessa',
    'freeShipping': 'Envio Grátis',
    'inStock': 'Em estoque',
    'quantity': 'Quantidade',
    'addToCart': 'Adicionar ao carrinho',
    'buyNow': 'Compre Agora',
    'price': 'Preço',
    'about': 'Sobre este item',
    'description': 'Descrição',
    'reviews': 'Avaliações',
    'details': 'Detalhes do produto',
    'cart': 'Carrinho',
    'summary': 'Resumo do pedido',
    'total': 'Total',
    'discount': 'Desconto',
    'subtotal': 'Subtotal',
    'continue': 'Continue comprando',
    'checkout': 'Verificação de saída'
  },
  'menu': {
    'search': 'Pesquisar (pressione \'ctrl + /\' para focar)',
    'dashboard': 'Painel de controle',
    'logout': 'Sair',
    'profile': 'Perfil',
    'blank': 'Página em branco',
    'pages': 'Páginas',
    'others': 'Outras',
    'email': 'Email',
    'chat': 'Chat',
    'todo': 'Tarefas',
    'board': 'Quadro de Tarefas',
    'users': 'Utilizadores',
    'usersList': 'Lista',
    'usersEdit': 'Editar',
    'ecommerce': 'Comércio eletrônico',
    'ecommerceList': 'Produtos',
    'ecommerceProductDetails': 'Detalhes do produto',
    'ecommerceOrders': 'Pedidos',
    'ecommerceCart': 'Carrinho',
    'auth': 'Páginas de autenticação',
    'authLogin': 'Signin / Login',
    'authRegister': 'Inscrição / Registro',
    'authVerify': 'Verificar e-mail',
    'authForgot': 'Esqueceu a senha',
    'authReset': 'Redefinir senha',
    'errorPages': 'Páginas de Erro',
    'errorNotFound': 'Não encontrado / 404',
    'errorUnexpected': 'Inesperado / 500',
    'utilityPages': 'Páginas de utilitários',
    'utilityMaintenance': 'Manutenção',
    'utilitySoon': 'Em breve',
    'utilityHelp': 'FAQs / Ajuda',
    'levels': 'Níveis de Menu',
    'disabled': 'Menu Desativado',
    'docs': 'Documentação',
    'feedback': 'Comentários',
    'support': 'Apoio, suporte',
    'landingPage': 'Landing Page',
    'pricingPage': 'Página de preços'
  },
  '$vuetify': {
    'badge': 'Distintivo',
    'close': 'Fechar',
    'dataIterator': {
      'noResultsText': 'Nenhum registro correspondente encontrado',
      'loadingText': 'Carregando itens ...'
    },
    'dataTable': {
      'itemsPerPageText': 'Linhas por página:',
      'ariaLabel': {
        'sortDescending': 'Ordenado em ordem decrescente.',
        'sortAscending': 'Ordenado em ordem crescente.',
        'sortNone': 'Não classificado.',
        'activateNone': 'Ative para remover a classificação.',
        'activateDescending': 'Ative para classificar em ordem decrescente.',
        'activateAscending': 'Ative para classificar em ordem crescente.'
      },
      'sortBy': 'Ordenar por'
    },
    'dataFooter': {
      'itemsPerPageText': 'Itens por página:',
      'itemsPerPageAll': 'Todos',
      'nextPage': 'Próxima página',
      'prevPage': 'Página anterior',
      'firstPage': 'Primeira página',
      'lastPage': 'Última página',
      'pageText': '{0} - {1} de {2}'
    },
    'datePicker': {
      'itemsSelected': '{0} selecionado',
      'nextMonthAriaLabel': 'Próximo mês',
      'nextYearAriaLabel': 'Próximo ano',
      'prevMonthAriaLabel': 'Mês anterior',
      'prevYearAriaLabel': 'Ano anterior'
    },
    'noDataText': 'Sem dados disponíveis',
    'carousel': {
      'prev': 'Visual anterior',
      'next': 'Próximo visual',
      'ariaLabel': {
        'delimiter': 'Slide do carrossel {0} de {1}'
      }
    },
    'calendar': {
      'moreEvents': 'Mais {0}'
    },
    'fileInput': {
      'counter': '{0} arquivos',
      'counterSize': '{0} arquivos ({1} no total)'
    },
    'timePicker': {
      'am': 'AM',
      'pm': 'PM'
    },
    'pagination': {
      'ariaLabel': {
        'wrapper': 'Navegação de paginação',
        'next': 'Próxima página',
        'previous': 'Página anterior',
        'page': 'Ir para a página {0}',
        'currentPage': 'Página atual, página {0}'
      }
    }
  }
}
